
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import MDButton from 'components/MDButton';
// import MDInput from "components/MDInput";
import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from 'react-router-dom';
import { Oval } from 'react-loader-spinner';
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
// import { TextField } from "@mui/material";
import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
// import { Document, Text, StyleSheet, View, Image } from '@react-pdf/renderer';
import * as moment from 'moment';
import certLogo from "assets/images/CertificateLogo.png";
import satyaLogo from "assets/images/CertificateLogoOld.png";
import shivajiMLogo from "assets/images/Ch.Shivaji_LOGO.png";
import { jsPDF } from 'jspdf';
import html2canvas from "html2canvas";
import * as service from '../../services/service';

function GenerateSponsorshipCertificate() {
    const [data, setData] = useState([{}]);
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({});
    const certificateId = JSON.parse(sessionStorage.getItem('CertificateId'));
    const certificateNumber = JSON.parse(sessionStorage.getItem('CertificateNumber'));
    const outwardNumber = JSON.parse(sessionStorage.getItem('OutwardNumber'));
    const issueDate = JSON.parse(sessionStorage.getItem('IssueDate'));
    const navigate = useNavigate();
    const params = useParams();

    const getRegistrationById = () => {
        setLoading(true);
        // const errs = {};        
        if (params.id > 0) {
            fetch(
                service.GET_SPONSROSHIP_BY_ID,
                {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'XApiKey': JSON.parse(sessionStorage.getItem('userData')).apiKey
                    },
                    body: JSON.stringify({
                        SponsorshipId: params.id,
                    })
                })
                .then(res => res.json())
                .then(result => {
                    if (result.message.messageType === 'Success') {
                        setData(result);
                    }
                    else {
                        // eslint-disable-next-line
                        alert(result.message.message);
                    }
                });
        }
        setLoading(false);
    };

    useEffect(() => {
        if (params.id > 0) {
            getRegistrationById();
        }
    }, []);


    const submitHandler = e => {
        e.preventDefault();
        const errs = {};
        setLoading(true);
        const divToPrint = document.querySelector('#divForm');
        html2canvas(divToPrint).then(canvas => {
            const imgData = canvas.toDataURL('image/png');
            const imgWidth = 190;
            const pageHeight = 290;
            const imgHeight = (canvas.height * imgWidth) / canvas.width;
            let heightLeft = imgHeight;
            // eslint-disable-next-line new-cap
            const doc = new jsPDF('pt', 'mm');
            let position = 0;
            doc.addImage(imgData, 'PNG', 10, 0, imgWidth, imgHeight + 25, undefined, 'FAST');
            heightLeft -= pageHeight;
            while (heightLeft >= 0) {
                position = heightLeft - imgHeight;
                doc.addPage();
                doc.addImage(imgData, 'PNG', 10, position, imgWidth, imgHeight + 25);
                heightLeft -= pageHeight;
            }
            // const doc1 = addWaterMark(doc);
            const blob = doc.output('blob');
            // doc.toBlob(blob => {
            const certFile = new File([blob], 'Certificate.pdf');
            const formData = new FormData();
            formData.append("SponsorshipId", params.id ? params.id : null);
            formData.append("SponsorshipCertificateId", certificateId);
            formData.append("IssueDate", (new Date(issueDate)).toUTCString());
            formData.append("CertificateNumber", certificateNumber);
            formData.append("OutwardNumber", outwardNumber);
            formData.append("CertificateFile", certFile);
            formData.append("AddedBy", JSON.parse(window.sessionStorage.getItem('userData')).userId);
            fetch(
                service.ADD_UPDATE_SPONSORSHIP_CERTIFICATE,
                {
                    method: 'POST',
                    headers: {
                        'XApiKey': JSON.parse(sessionStorage.getItem('userData')).apiKey
                    },
                    body: formData
                })
                .then(res => res.json())
                .then(result => {
                    if (result.messageType === 'Success') {
                        // eslint-disable-next-line
                        alert(result.message);
                        sessionStorage.setItem('CertificateNumber', null);
                        sessionStorage.setItem('IssueDate', null);
                        sessionStorage.setItem('OutwardNumber', null);
                        sessionStorage.setItem('CertificateId', null);
                        navigate('/sponsorships');
                    }
                    else if (result.messageType === 'Failed') {
                        // eslint-disable-next-line
                        alert(result.message);
                        sessionStorage.setItem('CertificateNumber', null);
                        sessionStorage.setItem('IssueDate', null);
                        sessionStorage.setItem('OutwardNumber', null);
                        sessionStorage.setItem('CertificateId', null);
                        navigate('/sponsorships');
                    }
                    else {
                        errs[".invalid"] = result.message.message;
                        setErrors(errs);
                    }
                });
        });
        // }, 'image/png')
        setLoading(false);
    }

    const backHandler = () => {
        navigate('/sponsorships');
    };

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox pt={6} pb={3}>
                <Grid container spacing={6}>
                    <Grid item xs={12}>
                        <Card>
                            <MDBox
                                mx={2}
                                mt={-3}
                                py={3}
                                px={2}
                                variant="gradient"
                                bgColor="info"
                                borderRadius="lg"
                                coloredShadow="info"
                            >
                                <MDTypography variant="h6" color="white">
                                    Sponsorship Certificate
                                </MDTypography>
                            </MDBox>
                            <Card style={{ alignItems: 'center' }}>
                                <div id="divForm" width="100%">
                                    <br />
                                    <Table id="tblCertificate" style={{ "borderWidth": "5px", 'borderColor': "lightcoral", 'borderStyle': 'solid' }}>
                                        <TableRow>
                                            <TableCell colSpan="3" align="center">
                                                <img src={satyaLogo} alt="Logo" height="100px" width="100px" />
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell colSpan="3" align="center" style={{ fontSize: '21px', fontWeight: 'bold', color: 'maroon' }}>
                                                Directorate of Tourism (DoT), Govt of Maharashtra
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell colSpan="3" align="center">
                                                <hr />
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell align="left">
                                                <img src={certLogo} alt="Logo" height="100px" width="100px" />
                                            </TableCell>
                                            <TableCell align="center" style={{ fontSize: '15px', fontWeight: 'bold', }}>
                                                HO: Sakhar Bhavan, 4th Floor, Plot No.230, Nariman Point, Mumbai - 400021.
                                                <br />
                                                Phone No:- 91-22-69107600
                                                <br />
                                                Email:- diot@maharashtratourism.gov.in
                                                <br />
                                                Website:- www.maharashtratourism.gov.in
                                            </TableCell>
                                            <TableCell align="right">
                                                <img src={shivajiMLogo} alt="Logo" height="100px" width="100px" />
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell colSpan="3" align="center">
                                                <hr />
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell style={{ fontSize: '16px', fontWeight: 'bold' }}>
                                                {certificateNumber}
                                            </TableCell>
                                            <TableCell />
                                            <TableCell align="right" style={{ fontSize: '16px', fontWeight: 'bold' }}>
                                                Date : {moment(issueDate).format('DD-MM-YYYY')}
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell colSpan="3" style={{ fontSize: '16px', fontWeight: 'bold' }}>
                                                To,
                                                <br />
                                                {data.applicantName},
                                                <br />
                                                {data.address},
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell colSpan="3" style={{ fontSize: '1px', fontWeight: 'bold' }}>
                                                Subject: Participation in {data.sponsorshipFor}.
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell colSpan="3" style={{ fontSize: '16px', fontWeight: 'bold' }}>
                                                Reference: 1. Your proposal dated {moment(data.registrationDate).format('DD-MM-YYYY')}.
                                                <br />
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                2. Govt Letter {data.inwardNo} dated {moment(data.approvalDate).format('DD-MM-YYYY')}.
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell colSpan="3" style={{ fontSize: '16px', fontWeight: 'bold' }}>
                                                Sir/Madam,
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell colSpan="3" style={{ fontSize: '16px', fontWeight: 'bold' }}>
                                                This is to inform you that your proposal for Maharashtra Tourism to participate in {data.sponsorshipFor} as Sponsorship of {data.sponsorshipAmount} has been approved by the Tourism Department Govt. of Maharashtra as mentioned in Reference No. 2.
                                                <br />
                                                You are requested to provide all deliverables mentioned in proposal.
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell colSpan="3" style={{ fontSize: '16px', fontWeight: 'bold' }}>
                                                Deliverables
                                            </TableCell>
                                        </TableRow>
                                        {data.deliverable1 !== '' ?
                                            <TableRow>
                                                <TableCell colSpan="3" style={{ fontSize: '16px', fontWeight: 'bold' }}>
                                                    1. {data.deliverable1}
                                                </TableCell>
                                            </TableRow>
                                            : null}
                                        {data.deliverable2 !== '' ?
                                            <TableRow>
                                                <TableCell colSpan="3" style={{ fontSize: '16px', fontWeight: 'bold' }}>
                                                    2. {data.deliverable2}
                                                </TableCell>
                                            </TableRow>
                                            : null}
                                        {data.deliverable3 !== '' ?
                                            <TableRow>
                                                <TableCell colSpan="3" style={{ fontSize: '16px', fontWeight: 'bold' }}>
                                                    3. {data.deliverable3}
                                                </TableCell>
                                            </TableRow>
                                            : null}
                                        {data.deliverable4 !== '' ?
                                            <TableRow>
                                                <TableCell colSpan="3" style={{ fontSize: '16px', fontWeight: 'bold' }}>
                                                    4. {data.deliverable4}
                                                </TableCell>
                                            </TableRow>
                                            : null}
                                        {data.deliverable5 !== '' ?
                                            <TableRow>
                                                <TableCell colSpan="3" style={{ fontSize: '16px', fontWeight: 'bold' }}>
                                                    5. {data.deliverable5}
                                                </TableCell>
                                            </TableRow>
                                            : null}
                                        {data.deliverable6 !== '' ?
                                            <TableRow>
                                                <TableCell colSpan="3" style={{ fontSize: '16px', fontWeight: 'bold' }}>
                                                    6. {data.deliverable6}
                                                </TableCell>
                                            </TableRow>
                                            : null}
                                        {data.deliverable7 !== '' ?
                                            <TableRow>
                                                <TableCell colSpan="3" style={{ fontSize: '16px', fontWeight: 'bold' }}>
                                                    7. {data.deliverable7}
                                                </TableCell>
                                            </TableRow>
                                            : null}
                                        {data.deliverable8 !== '' ?
                                            <TableRow>
                                                <TableCell colSpan="3" style={{ fontSize: '16px', fontWeight: 'bold' }}>
                                                    8. {data.deliverable8}
                                                </TableCell>
                                            </TableRow>
                                            : null}
                                        {data.deliverable9 !== '' ?
                                            <TableRow>
                                                <TableCell colSpan="3" style={{ fontSize: '16px', fontWeight: 'bold' }}>
                                                    9. {data.deliverable9}
                                                </TableCell>
                                            </TableRow>
                                            : null}
                                        {data.deliverable10 !== '' ?
                                            <TableRow>
                                                <TableCell colSpan="3" style={{ fontSize: '16px', fontWeight: 'bold' }}>
                                                    10. {data.deliverable10}
                                                </TableCell>
                                            </TableRow>
                                            : null}
                                        <TableRow>
                                            <TableCell colSpan="3" style={{ fontSize: '16px', fontWeight: 'bold' }}>
                                                As agreed by you, a due mileage may be given to Maharashtra Tourism during the said conclve with logo publicity. After completion of the program publicity report (deliverables completion), in triplicate should be submitted to this office along with Photocopy of Payee Code should be provided.
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell colSpan="3" style={{ fontSize: '16px', fontWeight: 'bold' }}>
                                                Alcohol or any other intoxicating substances must not be displayed or sold during the said festival/event. If any such activity is found, the logo collaboration/approval granted for the festival/event will be cancelled immediately. Please take note of this.
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell colSpan="3" align="right" style={{ fontSize: '16px', fontWeight: 'bold' }}>
                                                Regards,
                                                <br />
                                                {JSON.parse(sessionStorage.getItem('userData')).userName}
                                                <br />
                                                {JSON.parse(sessionStorage.getItem('userData')).userRole}
                                                <br />
                                            </TableCell>
                                        </TableRow>
                                    </Table>
                                </div>
                                <Table>
                                    <TableRow>
                                        <TableCell>
                                            {loading ? <Oval
                                                heigth="20"
                                                width="20"
                                                color='grey'
                                                ariaLabel='loading'
                                            /> :
                                                <MDButton color="info" onClick={submitHandler}>
                                                    Save
                                                </MDButton>
                                            }
                                        </TableCell>
                                        <TableCell>
                                            <MDButton color="secondary" onClick={backHandler}>
                                                Back
                                            </MDButton>
                                        </TableCell>
                                    </TableRow>
                                </Table>
                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".error"]}</div>
                            </Card>
                        </Card>
                    </Grid>
                </Grid>
            </MDBox>
            <Footer />
        </DashboardLayout>
    );
}

export default GenerateSponsorshipCertificate;